import React, { useEffect, useState } from 'react';
import backicon from './../../../../../../Assets/icons/backIcon.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import DynamicForm from '../../../../../customformComponent/customForm/DynamicForm';
import axiosInstance from '../../../../../services/api/API';
import Swal from 'sweetalert2';
import Loader from '../../../../../customComponents/CustomLoader';
import validations from '../../../../../../helpers/validations';
import { buttonStyle, isFormValid } from '../../../../../../helpers/common';

const EditUnit = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const Token = localStorage.getItem('authToken');
  const [editUnit, setEditUnit] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [userTypedd, setUserTypedd] = useState([]);
  const location = useLocation();
  const { data } = location.state || {};

  const fetchUnitEdit = async () => {
    try {
      const response = await axiosInstance.get(`/unit/edit/${data.unit_id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Token}`,
        },
      });
      const formatData = response.data.data;
      const formatedData = {
        unit: formatData.unit,
        unit_desc: formatData.unit_desc,
        status: formatData.status === 1 ? true : false,
      };
      setFormData(formatedData);
      setEditUnit(formatData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUnitEdit();
  }, []);

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    // Validate required fields
    UnitInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = 'This field is required';
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to update this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    if (confirmation.isConfirmed) {
      try {
        setLoading(true);
        const payload = {
          unit: formData.unit,
          unit_desc: formData.unit_desc,
          status: formData.status === true ? 1 : 0,
        };

        await axiosInstance.patch(`/unit/update/${data.unit_id}`, payload, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Token}`,
          },
        });
        await Swal.fire({
          title: 'Success',
          text: 'Unit updated successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        navigate('/admin/manage-logistic/unit');
      } catch (error) {
        console.error('Error updating unit:', error);
        const errorMessage =
          error.response?.data?.message ||
          'An error occurred while processing your request.';
        await Swal.fire({
          title: 'Something went wrong',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const backNavigate = () => {
    navigate('/admin/manage-logistic/unit');
  };

  const UnitInputs = [
    {
      name: 'unit',
      label: 'Name',
      type: 'text',
      required: true,
      gridClass: 'col-lg-4',
      validation: validations.unitName({ required: true }),
      disabled: true,
    },
    {
      name: 'unit_desc',
      label: 'Description',
      type: 'text',
      required: true,
      gridClass: 'col-lg-4',
      validation: validations.description({ required: true }),
    },
    {
      name: 'status',
      label: 'Status',
      type: 'toggle',

      gridClass: 'col-lg-4',
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Edit Unit</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter the Unit Details
              </span>
              <DynamicForm
                validateOnMount
                formConfig={UnitInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(UnitInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  UnitInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => handleFormSubmit(formData)}
              >
                {loading ? 'Processing...' : 'Submit'}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditUnit;
